import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreviewPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.83333 4.16667L10.7239 2.27614C11.2446 1.75544 12.0888 1.75544 12.6095 2.27614L13.7239 3.39052C14.2446 3.91122 14.2446 4.75544 13.7239 5.27614L11.8333 7.16667M8.83333 4.16667L2.22386 10.7761C1.97381 11.0262 1.83333 11.3653 1.83333 11.719V14.1667H4.28105C4.63467 14.1667 4.97381 14.0262 5.22386 13.7761L11.8333 7.16667M8.83333 4.16667L11.8333 7.16667"
    />
  </svg>
);
export default SvgPreviewPencil;
